import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { BackOfficeService } from "./services/backOffice.service";
import { BackOfficeThemeService } from "./shared-backOffice/services/back-office-theme.service";
import {
  BackOfficeHierarchyContextService,
  BackOfficeHierarchyScope,
} from "./shared-backOffice/services/hierarchy-context.service";
import { BackOfficeHierarchySelection } from "./shared-backOffice/utils/hierarchy-helpers";

@Component({
  selector: "app-backOffice-layout",
  templateUrl: "./backOffice.component.html",
  styleUrls: ["./backOffice.component.css"],
})
export class BackOfficeComponent implements OnInit, OnDestroy {
  public isSidebarOpen = false;
  themeClass = "";
  hierarchySelection: BackOfficeHierarchySelection = {};
  hierarchyScope: BackOfficeHierarchyScope = "lane";

  private readonly subscriptions = new Subscription();

  constructor(
    private backOfficeService: BackOfficeService,
    private themeService: BackOfficeThemeService,
    private hierarchyContext: BackOfficeHierarchyContextService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.themeClass = this.themeService.activeTheme.className;
    this.subscriptions.add(
      this.backOfficeService.backOfficeSidebar$.subscribe((isOpen) => {
        this.isSidebarOpen = isOpen;
      }),
    );
    this.subscriptions.add(
      this.themeService.activeTheme$.subscribe((theme) => {
        this.themeClass = theme.className;
      }),
    );
    this.subscriptions.add(
      this.hierarchyContext.selection$.subscribe((selection) => {
        this.hierarchySelection = selection;
      }),
    );
  }

  ngOnInit(): void {
    this.updateHierarchyScope();
    this.subscriptions.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => this.updateHierarchyScope()),
    );
  }

  onHierarchySelectionChange(selection: BackOfficeHierarchySelection): void {
    this.hierarchyContext.setSelection(selection);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private updateHierarchyScope(): void {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    this.hierarchyScope = route.snapshot.data.hierarchyScope || "lane";
  }
}
